module.exports = __webpack_public_path__ + "static/img/cePath4.a9e70dea.gif";